var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMovSaldoDisp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.568 5.34844C12.4118 5.19223 12.1585 5.19223 12.0023 5.34844L7.70818 9.64255L5.61407 7.54844C5.45786 7.39223 5.20459 7.39223 5.04838 7.54844C4.89217 7.70465 4.89217 7.95792 5.04838 8.11413L7.42501 10.4908C7.56173 10.6275 7.77365 10.6448 7.92887 10.5415L7.92985 10.5408C7.95177 10.5263 7.97283 10.5093 7.99265 10.4895L12.568 5.91413C12.7242 5.75792 12.7242 5.50465 12.568 5.34844ZM11.4366 4.78276C11.9052 4.31413 12.665 4.31413 13.1337 4.78276C13.6023 5.25139 13.6023 6.01119 13.1337 6.47982L8.55833 11.0551C8.50051 11.113 8.43793 11.1639 8.37171 11.2077C7.90547 11.5178 7.27066 11.4678 6.85932 11.0564L4.4827 8.67981C4.01407 8.21119 4.01407 7.45139 4.4827 6.98276C4.95133 6.51413 5.71112 6.51413 6.17975 6.98276L7.70818 8.51118L11.4366 4.78276Z",
    fill: "#15D4B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99985 2.89991C4.90706 2.89991 2.39985 5.40712 2.39985 8.49992C2.39985 11.5927 4.90706 14.0999 7.99985 14.0999C11.0926 14.0999 13.5999 11.5927 13.5999 8.49992C13.5999 8.13178 13.5644 7.77231 13.4968 7.42462C13.4546 7.20777 13.5963 6.9978 13.8131 6.95564C14.03 6.91349 14.2399 7.05511 14.2821 7.27196C14.3594 7.66968 14.3999 8.08027 14.3999 8.49992C14.3999 12.0345 11.5345 14.8999 7.99985 14.8999C4.46523 14.8999 1.59985 12.0345 1.59985 8.49992C1.59985 4.96529 4.46523 2.09991 7.99985 2.09991C9.3078 2.09991 10.5252 2.4927 11.5391 3.16682C11.7231 3.28914 11.7731 3.53742 11.6507 3.72138C11.5284 3.90535 11.2801 3.95532 11.0962 3.83301C10.2095 3.24344 9.14538 2.89991 7.99985 2.89991Z",
    fill: "#15D4B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMovSaldoDisp);
export default __webpack_public_path__ + "static/media/iconMovSaldoDisp.aec758c16c3e12fda79a9e3a687f67fa.svg";
export { ForwardRef as ReactComponent };